import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useEffect, useState } from "react";
import SideBar from "../common/sidebar";
import NewWorkspace from "../../assets/images//newworkspace.png";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { loadUser } from "../../actions/auth";
import { LOGIN_SUCCESS } from "../../actions/types";
import Footer from "../common/footer";

export default function Workspace() {
  useTranslation();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [title, setWorkspace] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {}, []);

  const handleWorkspaceChange = (e) => {
    setWorkspace(e.target.value);
  };

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;
    if (title === "") {
      formIsValid = false;
      errors["title"] = "Please enter the Workspace Title";
    }
    setErrors(errors);
    return formIsValid;
  };

  const hanldeKeydown = () => {
    document.onkeypress = (e) => {
      e = e || window.event;
      if (e.keyCode === 13) {
        e.preventDefault();
        if (validateForm()) {
          createWorkspace();
        }
      }
    };
  };

  const createWorkspace = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ title });
    try {
      if (validateForm()) {
        let res = await axios.post("/api/workspace/create", body, config);
        if (res.status === 200) {
          //dispatch({type:LOGIN_SUCCESS,payload:res.data})
          dispatch(loadUser(res.data));
          window.location.reload();
        }
      }
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  return (
    <div>
      <SideBar />
      <div className="content-wrap" id="wrapper">
        <div className="main">
          <div className="create-new_workspace-container">
            <div className="new-workspace-top-page-steps">
              <div className="steps-contain">
                {/*<div className="step-item active-step"></div>
                        <div className="step-item"></div>
                        <div className="step-item"></div>*/}
              </div>
            </div>
            <div className="create-new-img">
              <img
                src={NewWorkspace}
                className="insight-image"
                alt={tr("Create new workspace")}
              />
            </div>
            <div className="In_wrk_create_title">
              <span>{tr("Create a workspace")}</span>
            </div>
            <div className="create_new_Info_contain">
              <div className="sub_content">
                <span>{tr("Give your workspace a name. Don't worry, you can change it later.")} </span>
              </div>
            </div>
            <div className="create_new-wrokspace-form-wrap">
              <form id="newworkspace_name">
                <div className="field-seprator">
                  <label className="create_field_label">
                    <span>{tr("Workspace Name")}</span>
                  </label>
                  <div className="new_workspace_field">
                    <input
                      type="text"
                      name="workspace"
                      value={title}
                      onChange={handleWorkspaceChange}
                      onKeyDown={hanldeKeydown()}
                    />
                    <span>{errors.title}</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="create_workspace_btn"
                  onClick={(e) => createWorkspace(e)}
                >
                  <span>{tr("Continue")}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
